import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonOrderedList} from 'mui-tiptap';

const StyledEditorMenuButtonOrderedList = styled(MenuButtonOrderedList)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonOrderedList.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonOrderedList;
